export default __webpack_public_path__ + "static/media/icon_cart.e0614387.svg";